import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { Loader2, AlertCircle, Mail } from "lucide-react";
import { LOGO_URL } from "@/lib/utils-tg";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MagicCallbackPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { adoptSession } = useAuth();
  const [status, setStatus] = useState("verifying"); // verifying | error
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setError("Missing token in URL.");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic/verify", { token });
        // Persist scope if work-email magic link
        if (data.scope_company_id) {
          localStorage.setItem("tg_company_id", data.scope_company_id);
        }
        adoptSession(data.access_token, data.user);
        nav("/", { replace: true });
      } catch (e) {
        setStatus("error");
        setError(e?.response?.data?.detail || "This link is invalid or expired.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="magic-callback-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <img src={LOGO_URL} className="h-20 w-auto object-contain" alt="Talk & Go" />
        </div>
        <div className="tg-card p-8 text-center">
          {status === "verifying" && (
            <>
              <Loader2 className="h-8 w-8 animate-spin text-emerald-600 mx-auto mb-3" />
              <div className="font-display text-lg font-bold text-slate-900">Signing you in…</div>
              <p className="text-sm text-slate-500 mt-1">Verifying your magic link.</p>
            </>
          )}
          {status === "error" && (
            <>
              <div className="h-12 w-12 rounded-full bg-rose-50 text-rose-600 mx-auto mb-4 flex items-center justify-center">
                <AlertCircle className="h-6 w-6" />
              </div>
              <div className="font-display text-lg font-bold text-slate-900">Link unusable</div>
              <p className="text-sm text-slate-500 mt-1">{error}</p>
              <Link to="/login" className="tg-btn-primary mt-5 inline-flex" data-testid="magic-go-login">
                <Mail className="h-4 w-4" /> Get a new link
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
